import config from "../config";
import { filesRoute } from "../api/routes"
import { CUSTOMISED_ASSETS_BASE_URL } from "../config/FeatureDashboardVarMap"

export const getFeatureAssetBaseUrl = (isForced) => {
    // This return is for local / non-s3, it will need another one for s3
    
    // console.log('PASS URL', isForced, process.env.REACT_APP_NODE_ENV,  config.axiosOrigin)
    if(process.env.REACT_APP_NODE_ENV == 'local' && !isForced) return filesRoute + '/' + CUSTOMISED_ASSETS_BASE_URL + '/'
    return config.cloudfrontBaseUrl + '/' + CUSTOMISED_ASSETS_BASE_URL + '/';
}